import type { HTMLAttributes, ReactNode } from 'react'

import styles from './PageHeader.module.css'

export interface PageHeaderProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title: ReactNode
  subtitle: ReactNode
  action?: ReactNode
}

export function PageHeader({ title, subtitle, action, className = '', ...props }: PageHeaderProps) {
  return (
    <header className={`${styles.header} ${className}`} {...props}>
      <div><h1 className={styles.title}>{title}</h1><p className={styles.subtitle}>{subtitle}</p></div>
      {action}
    </header>
  )
}
